module.exports = __webpack_public_path__ + "img/technology1.1560d8a0.png";